export default __webpack_public_path__ + "static/media/content_verified.52043357.svg";